import ForgottenPasswordStep2Page from "./ForgottenPasswordStep2Page";

export default ForgottenPasswordStep2Page;
